import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useFetchAuthenticatedUserQuery } from "@/entities/me/api/fetch-authenticated-user";
import { ONBOARDING_ROUTE } from "@/shared/lib/routes";

const AuthedIndexRoute = () => {
  const me = useFetchAuthenticatedUserQuery();
  const { companies } = me;

  // No accessible companies (e.g. after deleting the last one) — there's no
  // company to route into, so send the user to onboarding to create one.
  if (companies.length === 0) {
    return <Navigate to={ONBOARDING_ROUTE} replace />;
  }

  if (!companies[0].onboardingCompletedAt && !me.isSuperAdmin) {
    return <Navigate to={ONBOARDING_ROUTE} replace />;
  }

  return (
    <Navigate
      to={"/$companySlug"}
      params={{ companySlug: companies[0].slug }}
      replace
    />
  );
};

export const Route = createFileRoute("/_authed/")({
  component: AuthedIndexRoute,
});
